import {BaseModel} from "../../_base/crud";

export interface ConfigurationsDetails {
    id: number;
    quantity: number;
    sellingPrice: number;
    stockDepotId?: number;
    stockId?: number;
}

type ProfessionalClientCategory = 'EMPLOYEE' | 'RETRIED' | 'MILITARY' | 'MILITARY_RETIRED';
type SocialClientCategory = 'SINGLE' | 'MARRIED' | 'DIVORCE' | 'WIDOWER';
type AccountType = 'CCP' | 'BANK' | 'BANKASBA';

export class OrderSplitAdmin extends BaseModel {
    id: number;
    clientId: number;
    configurationsDetails: ConfigurationsDetails[];
    dateOfBirthSimulation: string;
    birthDaySalary: string;
    email: string;
    numberOfMonths: number;
    phone: string;
    accountType: AccountType;
    pointOfSaleId: number;
    professionalClientCategory: ProfessionalClientCategory;
    salarySimulation: number;
    socialClientCategory: SocialClientCategory;
    commercialId: number;
    posId: number;
}
